const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship TNO Sports',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con agenda deportiva, fútbol y béisbol venezolano',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas deportivas, bebidas, retail, telecom y patrocinadores de eventos.',
    duration: 'Mensual',
    buttonText: 'Patrocinar TNO Sports',
    highlightedTitle: 'Deporte Multiplataforma',
    highlightedContent: [
      'Tu marca viaja con la credibilidad de TNO Sports.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Fútbol, béisbol y agenda en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Fútbol, Béisbol, Vinotinto o Agenda Deportiva',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan relevancia temática en deporte.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad deportiva',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con la pasión del deporte venezolano.',
      'Ideal para campañas de temporada y lanzamientos.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, productos o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Clubes, ligas, atletas, marcas deportivas y voceros comerciales.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de oferta con respaldo en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de TNO Sports y TNO Digest',
      'Contenido adaptado a deporte y lifestyle activo',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar una campaña deportiva.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Deportiva / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: agenda, promoción o activación de marca',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de temporada, equipos, eventos y lanzamientos deportivos.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de TNO Sports.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Deportivo',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo fan experience o testimonio con el producto',
      'Demostración en contexto deportivo o de uso real',
      'Narrativa humana alineada con pasión y comunidad',
      'Publicación del video en TNO y en TNO Sports',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de consumo deportivo, bebidas, apparel y equipamiento.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social deportiva',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad deportiva.',
      'Tu marca como recomendación de un aliado, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
